import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PaidRoute from './components/PaidRoute';

import Login from './pages/Login';
import Register from './pages/Register';
import Upload from './pages/Upload';
import Undress from './pages/Undress';
import Admin from './pages/Admin';
import Dashboard from './pages/Dashboard';
import Tokens from './pages/Tokens';
import Profile from './pages/Profile';
import PrivateShow from './pages/PrivateShow';
import LandingFunnel from './pages/LandingFunnel';
import AgeGateModal from './components/AgeGateModal';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen h-nsfw">
          <AgeGateModal />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Landing pré-pagamento; se hasPaid → /app */}
            <Route path="/" element={<LandingFunnel />} />

            {/* App principal — só após 1º pagamento */}
            <Route
              path="/app"
              element={
                <PaidRoute>
                  <Dashboard />
                </PaidRoute>
              }
            />
            <Route
              path="/ao-vivo"
              element={
                <PaidRoute>
                  <ProtectedRoute>
                    <PrivateShow />
                  </ProtectedRoute>
                </PaidRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <PaidRoute>
                  <Upload />
                </PaidRoute>
              }
            />
            <Route
              path="/undress"
              element={
                <PaidRoute>
                  <Undress />
                </PaidRoute>
              }
            />
            <Route
              path="/tokens"
              element={
                <PaidRoute>
                  <Tokens />
                </PaidRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PaidRoute>
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                </PaidRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <AdminRoute>
                  <Admin />
                </AdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
